<template>
    <footer class="footer footer--4">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <logo></logo>
                    <footer-nav></footer-nav>
                </div>
                <div class="col-lg-6">
                    <contacts></contacts>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <paysistems></paysistems>
                </div>
                <div class="col-lg-6">
                    <copyright></copyright>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import Logo from "./parts/Logo.vue";
import FooterNav from "./parts/FooterNav.vue";
import Contacts from "./parts/Contacts.vue";
import Paysistems from "./parts/Paysistems.vue";
import Copyright from "./parts/Copyright.vue";

export default {
    components: {
        Logo,
        FooterNav,
        Contacts,
        Paysistems,
        Copyright,
    },
};
</script>

<style lang="scss">
.footer--4 {
    &.footer {
        padding: 40px 0;
        background-color: $main-dark;
        .footer__logo {
            margin-bottom: 40px;
            img {
                max-width: 198px;
                height: auto;
            }
        }
        .footer__menu {
            display: flex;
            flex-direction: column;
            gap: 8px;
            margin-bottom: 40px;
            li {
                a {
                    color: $main-light;
                    @include font(16, 400);
                    transition: $transition;
                    &:hover {
                        color: $accent;
                    }
                }
            }
        }
        .footer__contacts {
          display: flex;
          flex-direction: column;
          gap: 8px;
          height: calc(100% - 40px);
          margin-bottom: 40px;
          max-width: 326px;

            &-item {
                @include font(16, 400);
                color: $main-light;
                &:first-child {
                  margin-bottom: 40px;
                }
            }
        }
        .footer__paysistems {
            display: flex;
            gap: 16px;
        }
        .footer__copyright {
            @include font(16, 400);
            color: $main-light;
        }
        @media (max-width: $breakpoint-lg) {
            padding: 24px 0;
            .footer__logo {
              margin-bottom: 25px;
              img {
                  max-width: 121px;
              }
            }
            .footer__menu {
                margin-bottom: 24px;
                li {
                    a {
                        @include font(14, 400);
                    }
                }
            }
            .footer__contacts {
                height: calc(100% - 24px);
                margin-bottom: 24px;
                &-item {
                    @include font(14, 400);
                }
            }
            .footer__paysistems {
                margin-bottom: 12px;
            }
            .footer__copyright {
                @include font(14, 400);
            }
        }
    }
}
</style>